export default "__VITE_ASSET__DxBDf3SX__"